import {
  FormConfigurationProvider,
  useFormConfigurationContext,
} from './context/formConfiguration.context'

export const FeatureFormConfigurationClientShared = {
  Provider: FormConfigurationProvider,
  use: useFormConfigurationContext,
}
